import { Link } from 'react-router-dom';
import SeoHead from '@/components/feature/SeoHead';
import { allArticles } from '@/mocks/categories';

const articleContents: Record<string, {
  title: string;
  summary: string;
  categoryName: string;
  categorySlug: string;
  date: string;
  readTime: string;
  sections: { heading: string; content: string }[];
}> = {
  'core-features': {
    title: 'jiuyou平台核心功能全面解析',
    summary: '深入了解jiuyou平台提供的全方位服务能力，从智能匹配到数据分析，覆盖用户全旅程。',
    categoryName: '平台介绍',
    categorySlug: 'platform-intro',
    date: '2026-08-01',
    readTime: '8分钟',
    sections: [
      { heading: '平台概述', content: 'jiuyou作为新一代智能服务平台，致力于为用户提供一站式解决方案。平台整合了智能匹配、数据分析、在线协作等多项核心功能，帮助个人用户和企业在数字时代提升效率。自上线以来，jiuyou已经服务超过500万用户，覆盖50余个城市，成为细分领域的领先平台。' },
      { heading: '智能匹配引擎', content: 'jiuyou的智能匹配引擎采用深度学习算法，能够根据用户的行为模式、偏好设置和历史数据，精准推荐最匹配的服务与内容。系统每天处理超过千万级的匹配请求，匹配准确率高达98.7%。无论是寻找合适的服务提供商还是发现感兴趣的内容，智能匹配都能让您在最短时间内找到最佳选择。' },
      { heading: '数据分析中心', content: '数据分析中心是jiuyou的核心功能之一。它能够自动采集用户在平台上的各类操作数据，通过可视化图表实时呈现关键指标。用户可以通过自定义仪表盘监控业务动态，利用AI预测功能提前洞察趋势变化。平台支持数据导出与API接入，方便与企业现有系统无缝对接。' },
      { heading: '多端协同体验', content: 'jiuyou全面支持PC端、移动端和小程序，三端数据实时同步，确保用户在任何设备上都能获得一致的使用体验。无论是在办公室使用电脑、通勤途中使用手机，还是通过小程序快速访问，都能流畅切换，工作不中断。平台采用了先进的PWA技术，即使在弱网环境下也能保持良好性能。' },
      { heading: '安全保障体系', content: '安全是jiuyou的生命线。平台采用银行级SSL/TLS加密传输、数据分片存储、异地多活容灾等先进技术，已通过ISO 27001信息安全认证和等保三级认证。平台还引入了生物识别认证、设备指纹识别等多重身份验证机制，确保只有授权用户才能访问敏感数据。' },
      { heading: '总结与展望', content: 'jiuyou将持续加大技术研发投入，计划在下半年推出AI助手、智能搜索等新功能。我们始终以用户需求为导向，不断优化产品体验，为每一位用户创造更大价值。感谢500万用户的信任与支持，jiuyou会继续努力，成为您最值得信赖的平台伙伴。' },
    ],
  },
  'why-choose-jiuyou': {
    title: '为什么选择jiuyou？五大理由告诉你',
    summary: '从安全性、效率、体验、价格、服务五个维度全面解读jiuyou的核心竞争力。',
    categoryName: '平台介绍',
    categorySlug: 'platform-intro',
    date: '2026-07-28',
    readTime: '6分钟',
    sections: [
      { heading: '理由一：顶级安全保障', content: '在互联网时代，数据安全是用户最关心的问题。jiuyou从设计之初就将安全置于最高优先级，采用多重加密技术和严格的身份验证机制，确保用户的每一笔交易、每一条数据都得到最完善的保护。平台已通过多项国际安全认证，让您用得放心。' },
      { heading: '理由二：极致使用效率', content: '时间就是金钱。jiuyou通过智能算法优化每一个操作流程，将复杂的多步骤操作简化为直观的一键式体验。根据用户反馈统计，使用jiuyou后平均工作效率提升47%，处理相同任务的时间缩短了三分之二。' },
      { heading: '理由三：优质用户体验', content: 'jiuyou拥有一支专业的用户体验设计团队，每一个界面、每一次交互都经过反复打磨。平台界面简洁直观、操作逻辑清晰自然，即便是初次使用的用户也能在几分钟内上手。用户满意度调查显示，jiuyou的NPS（净推荐值）高达76分，远高于行业平均水平。' },
      { heading: '理由四：灵活实惠定价', content: 'jiuyou提供多种套餐方案，从免费基础版到企业定制版，满足不同用户群体的需求。我们坚持透明定价原则，没有任何隐藏费用。相比同类平台，jiuyou的价格性价比高出30%以上，让每一分钱都物超所值。' },
      { heading: '理由五：专业贴心服务', content: 'jiuyou提供7×24小时全天候客户服务，平均响应时间不到30秒。无论是技术问题还是使用咨询，专业客服团队都能快速给出满意的解决方案。平台还建立了完善的用户反馈机制，每一条建议都会被认真对待并纳入产品迭代计划。' },
    ],
  },
};

export default function ArticleDetail() {
  const { slug } = useParams();
  const article = allArticles.find((a) => a.slug === slug);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [slug]);

  if (!article) {
    return (
      <section className="w-full px-4 md:px-6 py-20 bg-background-50">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-2xl font-heading font-bold text-foreground-950 mb-4">文章未找到</h1>
          <p className="text-sm text-foreground-600 mb-6">您访问的文章不存在或已被移除</p>
          <Link to="/articles" className="inline-block px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium">
            返回文章列表
          </Link>
        </div>
      </section>
    );
  }

  const content = slug && articleContents[slug]
    ? articleContents[slug]
    : {
        title: article.title,
        summary: article.summary,
        categoryName: article.categoryName,
        categorySlug: article.categorySlug,
        date: article.date,
        readTime: article.readTime,
        sections: [
          { heading: '概述', content: article.summary + ' 在jiuyou平台上，我们始终坚持以用户为中心的设计理念，不断优化产品体验，为每一位用户创造真实可见的价值。本文将从多个角度为您详细解读相关内容，帮助您更全面地了解jiuyou平台的能力与特色。' },
          { heading: '详细解读', content: 'jiuyou平台经过多年的技术积累和用户反馈迭代，已经形成了一套成熟、稳定的服务体系。无论是初次接触的新用户还是深度使用老用户，都能在jiuyou上找到最适合自己的使用方式。平台的智能匹配引擎能够根据用户的行为习惯自动推荐个性化的内容和功能，让每一次使用都高效而愉悦。' },
          { heading: '核心优势', content: '与其他同类平台相比，jiuyou在安全性、效率、体验和性价比方面都具有显著优势。我们拥有银行级数据加密、7×24小时专属客服、多端实时同步等行业领先的能力。超过500万的注册用户和99.9%的服务可用率，充分证明了jiuyou的可靠与稳定。' },
          { heading: '使用建议', content: '建议您从基础功能开始体验jiuyou，逐步探索更多高级特性。平台的帮助中心提供了详细的使用教程和常见问题解答。如果在使用过程中遇到任何问题，可以随时联系我们的客服团队，平均响应时间不到30秒。' },
          { heading: '展望未来', content: 'jiuyou将继续加大研发投入，计划推出更多创新功能，不断提升平台的服务能力。我们期待与每一位用户共同成长，将jiuyou打造成为更加智能、高效、值得信赖的首选平台。感谢您的关注与支持！' },
        ],
      };

  const canonicalUrl = `https://jiuyou.com/articles/${slug}`;

  return (
    <>
      <SeoHead
        data={{
          title: `${content.title} | jiuyou官网`,
          description: content.summary,
          canonicalUrl,
          ogType: 'article',
          publishedDate: content.date,
          modifiedDate: content.date,
        }}
      />

      <article className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
        <div className="max-w-3xl mx-auto">
          <header className="mb-10">
            <Link
              to="/categories"
              className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 mb-6"
            >
              <i className="ri-arrow-left-line" />
              {content.categoryName}
            </Link>
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4 leading-tight">
              {content.title}
            </h1>
            <p className="text-base text-foreground-600 mb-6 leading-relaxed">{content.summary}</p>
            <div className="flex items-center gap-5 text-sm text-foreground-500">
              <span className="flex items-center gap-1.5">
                <i className="ri-calendar-line" />
                {content.date}
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-time-line" />
                阅读时间 {content.readTime}
              </span>
            </div>
          </header>

          <div className="prose-custom">
            {content.sections.map((section, idx) => (
              <section key={idx} className="mb-8">
                <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-3">{section.heading}</h2>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed" style={{ lineHeight: '1.8' }}>
                  {section.content}
                </p>
              </section>
            ))}
          </div>

          <footer className="mt-12 pt-8 border-t border-background-200/60">
            <div className="flex items-center justify-between flex-wrap gap-4">
              <Link
                to={`/categories`}
                className="text-sm text-primary-500 hover:text-primary-600 flex items-center gap-1"
              >
                <i className="ri-arrow-left-line" />
                返回分类
              </Link>
              <div className="flex items-center gap-3">
                <span className="text-xs text-foreground-500">分享：</span>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors" rel="nofollow">
                  <i className="ri-wechat-line text-sm" />
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors" rel="nofollow">
                  <i className="ri-weibo-line text-sm" />
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors" rel="nofollow">
                  <i className="ri-link text-sm" />
                </a>
              </div>
            </div>
          </footer>
        </div>
      </article>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Article',
            headline: content.title,
            description: content.summary,
            datePublished: content.date,
            dateModified: content.date,
            author: { '@type': 'Organization', name: 'jiuyou' },
            publisher: { '@type': 'Organization', name: 'jiuyou' },
            url: canonicalUrl,
            articleSection: content.categoryName,
          }),
        }}
      />
    </>
  );
}